import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Index from "../views/Index.vue";
import Industry from "../views/Industry.vue";
import BlogPage from "../views/BlogPage.vue";
import blog from "../views/Blog.vue";
// import blog from "../views/Blog.vue";
import unit from "../views/unit.vue";
import AboutUs from "../views/AboutUs.vue";
import ContactUs from "../views/Contactus.vue";
import categories from "../views/categories.vue"
import redirect from "../views/redirect.vue"
import helpToAccessLocation from "../views/helpToAccessLocation.vue"

import industrialPark from "../views/industrialPark.vue"
Vue.use(VueRouter);
const routes = [{
    path: "/",
    component: Index,
    children: [
        { path: "/", component: Home, name: "home" },
        { path: "/categories", name: 'categories', component: categories },
        { path: "/Industry", name: 'industry', component: Industry },
        { path: "/page/:id/?slug", name: 'page', component: Industry },
        { path: "/BlogPage", name: "blog", component: BlogPage },
        { path: "/blog/:id/:slug?", name: "blogDetail", component: blog },
        { path: "/unit/:id/:slug?", name: "unit", component: unit },
        { path: "/AboutUs", name: "aboutUs", component: AboutUs },
        { path: "/ContactUs", name: "contactUs", component: ContactUs },
        { path: "/redirect", name: "redirect", component: redirect },
        { path: "/helpToAccessLocation", name: "helpToAccessLocation", component: helpToAccessLocation },
        { path: "/industrialPark", name: "industrialPark", component: industrialPark }
    ]
}];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        window.scrollTo(0, 0);
        // ...
    },
    routes
});

export default router;